import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const GOLD_FORMS = [
  'Coins',
  'Bars',
  'Jewelry'
];

const GOLD_STORAGE_LOCATIONS = [
  'Bank Vault',
  'Other'
];

const GoldFields = ({ formData, onFieldChange }) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="gold_purity_karats" className="portfolio-input-label">Purity (in Karats)</Label>
        <Input
          id="gold_purity_karats"
          placeholder="e.g. 24K, 22K, 18K"
          value={formData.gold_purity_karats}
          onChange={(e) => onFieldChange('gold_purity_karats', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="gold_form" className="portfolio-input-label">Form</Label>
        <Select 
          value={formData.gold_form} 
          onValueChange={(value) => onFieldChange('gold_form', value)}
        >
          <SelectTrigger className="portfolio-input">
            <SelectValue placeholder="Select form" />
          </SelectTrigger>
          <SelectContent>
            {GOLD_FORMS.map((form) => (
              <SelectItem key={form} value={form}>{form}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="gold_weight_oz" className="portfolio-input-label">Weight (in ounces)</Label>
        <Input
          id="gold_weight_oz"
          type="number"
          step="0.01"
          placeholder="0.00"
          value={formData.gold_weight_oz}
          onChange={(e) => onFieldChange('gold_weight_oz', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="gold_purchase_price_per_oz" className="portfolio-input-label">Purchase Price (per ounce)</Label>
        <Input
          id="gold_purchase_price_per_oz"
          type="number"
          step="0.01"
          placeholder="0.00"
          value={formData.gold_purchase_price_per_oz}
          onChange={(e) => onFieldChange('gold_purchase_price_per_oz', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="gold_current_price_per_oz" className="portfolio-input-label">Current Price (per ounce)</Label>
        <Input
          id="gold_current_price_per_oz"
          type="number"
          step="0.01"
          placeholder="0.00"
          value={formData.gold_current_price_per_oz}
          onChange={(e) => onFieldChange('gold_current_price_per_oz', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="gold_storage_location" className="portfolio-input-label">Storage Location</Label>
        <Select 
          value={formData.gold_storage_location} 
          onValueChange={(value) => onFieldChange('gold_storage_location', value)}
        >
          <SelectTrigger className="portfolio-input">
            <SelectValue placeholder="Select storage location" />
          </SelectTrigger>
          <SelectContent>
            {GOLD_STORAGE_LOCATIONS.map((location) => (
              <SelectItem key={location} value={location}>{location}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </>
  );
};

export default GoldFields;
